// górna belka panelu handlowca: logo, wyszukiwanie klienta, utwórz+, powiadomienia

import React, { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Paper } from '@mui/material';

import { useGetTraderClients } from 'api/endpoints';
import { Link, Loader, Modal } from 'components/controls';
import { Plus, Stars } from 'react-bootstrap-icons';
import { WiseSearch, WiseAvatar } from 'components/wise';

import logo from 'assets/logo.svg';

import styles from 'theme/components/layouts/MainLayout/components/HeaderTopBar/TraderPanelTopBar.module.scss';

const TraderPanelTopBar = () => {
  const { t } = useTranslation();
  const [searchKeyword, setSearchKeyword] = useState('');
  const [notificationsModalOpen, setNotificationsModalOpen] = useState(false);
  const searchWrapperRef = useRef<HTMLDivElement>(null);

  const { data, isFetching } = useGetTraderClients(searchKeyword);
  const clients = data?.items ?? [];
  const showDropdown = searchKeyword.trim().length > 0;

  // Zamykanie dropdown przy kliknięciu poza
  useEffect(() => {
    if (!showDropdown) return;
    const handleClickOutside = (event: MouseEvent) => {
      if (searchWrapperRef.current && !searchWrapperRef.current.contains(event.target as Node)) {
        setSearchKeyword('');
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showDropdown]);

  return (
    <div className={styles.traderPanelTopBar}>
      <Link to="/" className={styles.traderPanelLogo}>
        <img src={logo} alt="" />
      </Link>
      <div className={styles.traderPanelSearch} ref={searchWrapperRef}>
        <WiseSearch
          placeholder={t('Szukaj klienta')}
          value={searchKeyword}
          onChange={setSearchKeyword}
          debounced
          debounceTime={300}
        />
        {showDropdown && (
          <Paper elevation={3} className={styles.clientsDropdown}>
            {isFetching ? (
              <div className={styles.clientsDropdownLoading}>
                <Loader />
              </div>
            ) : clients.length === 0 ? (
              <div className={styles.clientsDropdownEmpty}>{t('Brak wyników')}</div>
            ) : (
              <ul className={styles.clientsDropdownList}>
                {clients.map((client) => (
                  <li key={client.id}>
                    <Link
                      to={`/trader/clients/${client.id}`}
                      className={styles.clientsDropdownItem}
                      onClick={() => setSearchKeyword('')}>
                      <WiseAvatar
                        small
                        className={styles.clientsDropdownAvatar}
                        withDetails
                        userData={{
                          first_name: client.name,
                          last_name: '',
                          email: client.email
                        }}
                      />
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </Paper>
        )}
      </div>
      <Button
        component={Link}
        to="/trader/clients/new"
        color="secondary"
        variant="contained"
        size="small"
        endIcon={<Plus size={24} />}
        className={styles.traderPanelButton}>
        <span className={styles.traderPanelButtonText}>{t('utwórz')}</span>
      </Button>
      {/*<Button*/}
      {/*  color="secondary"*/}
      {/*  variant="outlined"*/}
      {/*  size="small"*/}
      {/*  startIcon={<Stars size={24} />}*/}
      {/*  className={styles.traderPanelButton}*/}
      {/*  onClick={() => setNotificationsModalOpen(true)}>*/}
      {/*  <span className={styles.traderPanelButtonText}>{t('Masz nowe powiadomienia')}</span>*/}
      {/*</Button>*/}
      <Modal
        title={t('Masz nowe powiadomienia')}
        open={notificationsModalOpen}
        onClose={() => setNotificationsModalOpen(false)}>
        {t('Funkcja niezaiplementowana')}
      </Modal>
    </div>
  );
};

export default TraderPanelTopBar;
